import React, {ReactElement, useEffect, useState} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";
import Logo from "../../../assets/icons/CellTrak-logo.svg"
import { getMyPermissionConfig } from "../../../modules/auth/AuthApi";

export interface ISecure {
    children: ReactElement
}

export default function Secure({ children } : ISecure) {
    const { isLoading, user, isAuthenticated, loginWithRedirect } = useAuth0();
    const location = useLocation();
    const [authError, setAuthError] = useState<{ error: string; description: string } | null>(null);

    // Check for Auth0 errors in URL
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const error = searchParams.get('error');
        const errorDescription = searchParams.get('error_description');
        
        if (error) {
            setAuthError({
                error: error,
                description: errorDescription || 'An authentication error occurred'
            });
        } else {
            setAuthError(null);
        }
    }, [location]);

    useEffect(() => {
        // Don't attempt login if there's an error or if already loading/authenticated
        if (authError || isLoading || isAuthenticated) {
            return;
        }
        
        if (!isLoading && !isAuthenticated) {
            loginWithRedirect();
        }
    }, [isLoading, user, isAuthenticated, loginWithRedirect, authError]);

    // Show error message if Auth0 returned an error
    if (authError) {
        return (
            <div className="loading-screen">
                <div className="loading-screen__left">
                    <img src={Logo}></img>
                    <div style={{ marginTop: '2rem', padding: '1rem', backgroundColor: '#F8EAE9', border: '1px solid #B6281E', borderRadius: '4px', maxWidth: '500px' }}>
                        <h3 style={{ color: '#B6281E', marginTop: 0 }}>Authentication Error</h3>
                        <p style={{ color: '#B6281E', marginBottom: '0.5rem' }}>
                            <strong>Error:</strong> {authError.error}
                        </p>
                        <p style={{ color: '#B6281E', marginBottom: 0 }}>
                            <strong>Description:</strong> {decodeURIComponent(authError.description)}
                        </p>
                        <p style={{ marginTop: '1rem', fontSize: '0.875rem' }}>
                            Please contact your administrator if this issue persists.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {isAuthenticated && user && children}
            {(!isAuthenticated || !user) &&
                <div className="loading-screen">
                    <div className="loading-screen__left">
                        <img src={Logo}></img>
                    </div>
                </div>
            }
        </>
    );
}